import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateLocalRequestDTO, UpdateLocalBasicInfoDTO, UpdateLocalContactInfoDTO, UpdateLocalDTO } from "../models/local/local.request";
import { GetLocalResponse, LocalLinksInfoDTO, LocalDashboardInfoDTO, LocalInitClientDTO, LocalPlanSubscriptionInfo, LocalSettingsInfoDTO, SelectLocalInfoDTO, LocalInfoDTO, LocalQRCodeDataDTO } from "../models/local/local.response";



export const localService = {

    async create(newLocal: CreateLocalRequestDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/locals", newLocal);
        return data;
    },

    async createFromJson(newLocal: unknown): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>("/locals/json", newLocal);
        return data;
    },

    async update(localId: string, updatedLocal: UpdateLocalDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}`, updatedLocal);
        return data;
    },

    async getInfo(id: string): Promise<ApiResponse<LocalInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocalInfoDTO>>(`/locals/${id}`);
        return data;
    },

    async getAll(): Promise<ApiResponse<GetLocalResponse[]>> {
        const { data } = await api.get<ApiResponse<GetLocalResponse[]>>("/locals");
        return data;
    },

    async softDelete(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${id}/delete`);
        return data;
    },

    async hardDelete(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${id}`);
        return data;
    },

    async restore(id: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${id}/restore`);
        return data;
    },

    async getByUserId(userId: string): Promise<ApiResponse<SelectLocalInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<SelectLocalInfoDTO[]>>(`/locals/select`, {
            params: {
                userId: userId
            }
        });
        return data;
    },

    async getSettingsInfo(localId: string): Promise<ApiResponse<LocalSettingsInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocalSettingsInfoDTO>>(`/locals/${localId}/settings`);
        return data;
    },

    async updateBasicInfo(localId: string, basicInfo: UpdateLocalBasicInfoDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/settings/basic`, basicInfo)
        return data;
    },

    async updateContactInfo(localId: string, contactInfo: UpdateLocalContactInfoDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/settings/contact`, contactInfo)
        return data;
    },

    async updateImagesInfo(localId: string, imagesInfo: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/settings/images`, imagesInfo)
        return data;
    },

    async getInitClientMenu(localId: string): Promise<ApiResponse<LocalInitClientDTO>> {
        const { data } = await api.get<ApiResponse<LocalInitClientDTO>>(`/locals/${localId}/client`);
        return data;
    },

    async getLocalsPlanSubscriptionInfo(): Promise<ApiResponse<LocalPlanSubscriptionInfo[]>> {
        const { data } = await api.get<ApiResponse<LocalPlanSubscriptionInfo[]>>('/locals/subscriptions');
        return data;
    },

    async getLocalDashboardInfo(localId: string): Promise<ApiResponse<LocalDashboardInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocalDashboardInfoDTO>>(`/locals/${localId}/dashboard`);
        return data;
    },

    async getLocalsForSelect(): Promise<ApiResponse<SelectLocalInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<SelectLocalInfoDTO[]>>("/locals/input-select");
        return data;
    },

    async getLocalLinksBySlug(slug: string): Promise<ApiResponse<LocalLinksInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocalLinksInfoDTO>>(`/locals/${slug}/links`);
        return data;
    },

    async getLocalDataForQrCode(slug: string): Promise<ApiResponse<LocalQRCodeDataDTO>> {
        const { data } = await api.get<ApiResponse<LocalQRCodeDataDTO>>(`/locals/${slug}/settings/qr-code`);
        return data;
    }

};